import React, { forwardRef } from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import SignaturePad from "react-signature-pad-wrapper";
import BaseUserInfo from "../../types/BaseUserInfo";
import Button from "../Common/Button";
import { SignatureManager } from "../../hooks/useSignature";

type SignatureModalProps = {
    resources: Resources;
    SignatureManager: SignatureManager;
};

const SignatureModal = forwardRef<any, SignatureModalProps>((props, ref) => {
    const {
        signature,
        showSignatureModal,
        nameClarificationInput,
        includePhoneNumber = false,
        setNameClarificationInput,
        setPhoneNumberInput,
        errorMessage,
        clearSignatureCanvasButtonClickHandler: onClearSignatureCanvasButtonClick,
        saveSignatureButtonClickHandlerAsync: onSaveSignatureButtonClick
    } = props.SignatureManager;

    const nameClarificationInputId = `${signature.signatureType}-name-clarification`;

    return (
        <Modal show={showSignatureModal} onHide={props.SignatureManager.hideSignatureModalHandler} size="xl">
            <Modal.Header closeButton>
                <h1 className="h4">{props.resources.get("AddSignature")}</h1>
            </Modal.Header>

            <Modal.Body>
                <div className="border border-dark rounded mb-2">
                    <SignaturePad ref={ref} />
                </div>
                <div>
                    <label className="fw-bold" htmlFor={nameClarificationInputId}>
                        {props.resources.get("NameClarification")}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id={nameClarificationInputId}
                        value={nameClarificationInput}
                        onChange={(e) => setNameClarificationInput(e.target.value)}
                    />
                </div>
                {includePhoneNumber ? (
                    <div className="mt-2">
                        <label className="fw-bold" htmlFor="phone-number-input">
                            {props.resources.get("PhoneNumber")}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="phone-number-input"
                            value={props.SignatureManager.phoneNumberInput}
                            onChange={(e) => setPhoneNumberInput(e.target.value)}
                        />
                    </div>
                ) : null}
                <span className="text-danger">{errorMessage}</span>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                    <Button onClick={onSaveSignatureButtonClick}>{props.resources.get("SaveSignature")}</Button>
                    <Button variant="secondary" onClick={onClearSignatureCanvasButtonClick}>
                        {props.resources.get("ResetSignature")}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
});

export default SignatureModal;
